"use client";

import dynamic from "next/dynamic";
import { Skeleton } from "@/components/atoms/skelton";
import type {
  GetPremierResidenceListQuery,
  GetResidenceFormDatasourceQuery,
} from "@/types/generated";

const InquiryForm = dynamic(() => import("./InquiryForm"), {
  ssr: false,
  loading: () => (
    <Skeleton className="h-12 w-[180px] rounded-md bg-gray-200" />
  ),
});

interface LazyInquiryFormProps {
  inquiryFormQuery?: GetResidenceFormDatasourceQuery;
  premierResidenceList?: GetPremierResidenceListQuery;
  triggerButton: {
    label?: string | null;
    className?: string;
    showIcon?: boolean;
  };
}

const LazyInquiryForm = (props: LazyInquiryFormProps) => {
  return <InquiryForm {...props} />;
};

export { LazyInquiryForm };
export default LazyInquiryForm;
